import React, { Component } from 'react';
import { Header } from './header.js';
import { Footer } from './footer.js';
import { CategorySelectorList } from './category-selector-rewrite';
import * as util from './util';
import { logBusinessActivities } from './business_activities';
import './other.css';
import { FeeBoxXU } from './feebox-xu';

import { TextInfo, TextLine, TextField, Price, Tags,
         CheckBox, AGBCheckBox, SubmitButton, MultipleFileUpload } from './common-form-components.js';

var introductoryText = '<p> Hier können Sie alles auf dem Marktplatz der Ayacandas anbieten, wofür Sie sonst keine besondere Kategorie gefunden haben. <br /> <br /> <p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>';

let faqSoftware = [
  {
    content: "Hier können Sie alles auf dem Marktplatz der Ayacandas anbieten, wofür Sie sonst keine besondere Kategorie gefunden haben.</br></br>Diese Sparte wird in ihren Angeboten immer wieder überprüft werden, ab einer lohnenden Menge wird im Marktplatz der Ayacandas eine neue Unterkategorie aufgebaut.",
    title: "Auf welcher Seite befinden Sie Sich jetzt?",
    key: 0
  },


];


export class CreateOther extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.fetchDataAndRedirect();
  }

  fetchDataAndRedirect() {
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/create-other-product`;
    var promise = fetch(url, {method: 'POST',
                              headers: headers,
                              body: ''
    })
      .then(response => response.json())
      .catch(function(exception) {
        alert('Konnte kein "anderes Produkt" anlegen!');
        console.error(`Could not create "other product"!`, exception);
      });
    promise.then(function(json) {
      self.props.history.replace(`/update-other/${json.id}`);
    });
  }

  render() {
    return(
      <div className="CreateOther">
      </div>
    )
  }
}

export class UpdateOtherWithFeebox extends Component {
  constructor(props) {
    super(props);
    this.updateFeeByPrice = this.updateFeeByPrice.bind(this);
    this.updateFeeByCategories = this.updateFeeByCategories.bind(this);
    this.countCategories = this.countCategories.bind(this);
    this.state={
                 price: 0,
                 categoryCount: 1
                };
  }

  updateFeeByPrice(price) {
    this.setState({price: price});
    return true;
  }

  updateFeeByCategories (categories) {
    this.setState ({categoryCount:this.countCategories(categories)});
    return true;
  }


  countCategories(categories) {
    // workaround: converting String to array (FIXME)
    if ((typeof categories ) === 'string') {
      categories = categories.split(",");
    }
     console.log(categories);
     var tempCats = [];
     var count = 0;
     for (let i = 0; i < 6; i++) {
      if (categories !== undefined && categories[i] !== null && categories[i] !== "" ) {
        if (!tempCats.includes(categories[i])) {
          tempCats.push(categories[i]);
          count = count+1;
        } 
      }
    }
    return count;
  }


  render() {
    return (
      <div className="UpdateOtherWithFeebox" >
        <UpdateOther history={this.props.history} match={this.props.match} updateFeeByPrice={this.updateFeeByPrice} updateFeeByCategories={this.updateFeeByCategories} />
        {util.isCommercialUser() &&
         <FeeBoxXU type="software" price={this.state.price} categoryCount={this.state.categoryCount} />}
      </div>
    )
  }
}


export class UpdateOther extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.update = this.update.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
    this.isValid = this.isValid.bind(this);
    this.save = this.save.bind(this);

    this.state = {
      startID: 2,
      id: null,
      name: '',
      categories: '',
      price: 0,
      aim: '',
      tags: '',
      desc: '',
      agb_agreement: false,
      pdf_files: ',,,,',
      image_files: ',,,,,,,,,',
      video_files: '',
      product_files: '',
      agreement_1: false,
      agreement_2: false,

    };

    this.fetchDataAndRedirect();
    this.globalFormData = {};
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState !== this.state) {
      return true;
    } else {
      return false;
    }
  }

  update(slot, value) {
    if(slot === 'price' && this.props.updateFeeByPrice !== undefined) {
      this.props.updateFeeByPrice(parseInt(value, 10));
    }
    if(slot === 'categories' && this.props.updateFeeByCategories !== undefined) {
      this.props.updateFeeByCategories(value);
    }

    this.globalFormData[slot] = value;
  }


  fetchDataAndRedirect() {
    var id = this.props.match.params['id'];
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/create-other-product`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: `id=${id}`
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Werte laden!');
        console.error(`Could not retrieve other data!`, exception);
      });
    promise.then(function (json) {
      self.setState({
        id: json.id,
        name: json.name,
        desc: json.desc,
        categories: json.categories,
        price: json.price,
        aim: json.aim,
        tags: json.tags,
        agb_agreement: json.agb_agreement,
        update_price_text: json.update_price_text,
        pdf_files: json.pdf_files,
        image_files: json.image_files,
        video_files: json.video_files,
        product_files: JSON.product_files,
        agreement_2: json.agreement_2,

      });
    })
  }

  isValid(categories) {

    if (categories === undefined)
      return false;

    if (categories === null)
      return false;

    if (categories === "")
      return false;

    if (typeof categories === 'string') {
      categories = categories.split(/,/);
    }

    var catInput = categories.map(item => parseInt(item, 10));
    for (var i = 0; i < categories.length; i++) {
      if (parseInt(catInput[i], 10) === catInput[i]) {
        return true;
      }
    }
    return false;
  }

  validateInput() {
    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length > 200) {
        alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
      if (this.globalFormData['name'].length > 200) {
        alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");
        return false;
      }
    }

    if (this.globalFormData['aim'] === undefined) {
      if (this.state.aim.length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
      if (this.state.aim.length > 5000) {
        alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 5000 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['aim'].length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
      if (this.globalFormData['aim'].length > 5000) {
        alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 5000 Zeichen.");
        return false;
      }
    }
    return true;
  }

  checkRequiredFields() {
    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length < 1) {
        alert("Der Name ist ein Pflichtfelder. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
    }

    if ((this.globalFormData['categories'] === undefined) && (!this.isValid(this.state.categories))) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }
    if (!this.isValid(this.globalFormData['categories'])) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }

    if (this.globalFormData['aim'] === undefined) {
      if (this.state.aim.length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
    } else {
      if (this.globalFormData['aim'].length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
    }

    if (this.globalFormData['price'] === undefined) {
      if (this.state.price.length === 0) {
        alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");
        return false;
      }
    } else {
      if (this.globalFormData['price'].length === 0) {
        alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");
        return false;
      }
    }


    if (this.globalFormData['agreement_2'] === undefined) {
      if (this.state.agreement_2 !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agreement_2'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }




    if (this.globalFormData['agb_agreement'] === false) {
      alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
      return false;
    }

    if (this.globalFormData['agb_agreement'] === undefined) {
      if (this.state.agb_agreement !== true) {
        alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
        return false;
      }
    }

    return true;
  }

  save(announce) {
    if (announce === true) {
      if (this.checkRequiredFields() === false) {
        return;
      }
    }

    if (announce === true) {
      if (this.validateInput() === false) {
        return;
      }
    }
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    var formData = new FormData();
    Object.keys(this.globalFormData).map(key => formData.append(key, self.globalFormData[key]));
    formData.append("id", this.state.id);
    if (announce === true) {
      formData.append('announce', true);
    } else {
      formData.append('announce', false);
    }
    formData.append('active', true);
    var url = `/api/update-other-product`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: formData
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Werte speichern!');
        console.error(`Could not save other data!`, exception);
      });
    promise.then(function (json) {
      alert('Werte wurden gespeichert.');
      if (announce === true) {
        logBusinessActivities("Hardware und sonstige Angebote gespeichert, allem zugestimmt und veroeffentlicht.", json.id);
      }
      self.globalFormData = {};
      self.setState({
        id: json.id,
        name: json.name,
        desc: json.desc,
        categories: json.categories,
        price: json.price,
        aim: json.aim,
        tags: json.tags,
        agb_agreement: json.agb_agreement,
        is_public: json.is_public,
        is_update_available: json.is_update_available,
        update_price_text: json.update_price_text,
        pdf_files: json.pdf_files,
        image_files: json.image_files,
        video_files: json.video_files,
        product_files: JSON.product_files,
        agreement_2: json.agreement_2,
        agreement_3: json.agreement_3,
        agreement_4: json.agreement_4,
        agreement_6: json.agreement_6,
        // new to used-software
        company: json.company,
        compnay_name: json.company_name,
        compnay_web: json.company_web,
      });
      self.props.history.push('/product-list');
    })
  }
  render() {
    return (
      <div>
      <div className="Landing" id="contentId">
           <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />


           <div className="ContentWithBackground">
             <div className="content" id="content">
               <div className="productHeader1">
                 Anbieten einer Hardware oder sonstige Angebote
               </div>
            <div className="productHeader2">
              <TextInfo content={introductoryText} />
            </div>
          <div className="productForm1 marginTop30">
          <div className="prodInputComp">
          <TextLine heading=" Was bieten Sie an?" subheading="Unter diesem Titel wird ihr Produkt angezeigt." obligatory={true} maxLength='200' value={this.state.name} placeholder="was bieten Sie an" slot='name' update={this.update} />
            </div>
          <CategorySelectorList value={this.state.categories} slot="categories" update={this.update} categoryLimit={6} />
          <TextField heading="Beschreibung" obligatory={true} maxLength='5000' value={this.state.aim} placeholder="Beschreibung" slot='aim' update={this.update} />
          {!util.isCommercialUser() && <Price heading="Listenpreis in Euro"
                                              subheading="85% des Netto-Preises, den Ayacandas durch den Weiterverkauf Ihres Produktes erzielt, wird Ihnen oder Ihrer Institution für das Zurverfügungstellen der Lizenz ausbezahlt." obligatory={true} maxLength='6' value={this.state.price} slot='price' update={this.update} />}
          {util.isCommercialUser() && <Price heading="Preis in Euro"
                                             obligatory={true} maxLength='6' value={this.state.price} slot='price' update={this.update} />}
          <Tags heading="Stichworte, um gefunden zu werden (max. 7, durch Komma getrennt)" placeholder="Tags/Stichworte" value={this.state.tags} slot='tags' update={this.update} match={this.props.match} maxTags={7} maxLength={150} onNewMessage={this.props.onNewMessage} />
          <MultipleFileUpload heading="Anhang: Dokumente, vorzugsweise als PDF-Datei (bitte nur fachliches Material)" value={this.state.pdf_files} slot="pdf_files" update={this.update} onNewMessage={this.props.onNewMessage} />
          <MultipleFileUpload heading="Anhang: Beschreibende Bilder oder Screenshots" value={this.state.image_files} slot="image_files" update={this.update} onNewMessage={this.props.onNewMessage} />
          <MultipleFileUpload heading="Anhang: Video, max. 5 GB" value={this.state.video_files} slot="video_files" update={this.update} onNewMessage={this.props.onNewMessage} />
          <MultipleFileUpload heading="Hier haben Sie die Möglichkeit, Ihr Produkt als eine Datei hochzuladen." value={this.state.product_files} slot="product_files" update={this.update} onNewMessage={this.props.onNewMessage} />
          <CheckBox heading="* Erklärung zum Besitz" content="Ich erkläre hiermit, dass das oder die angebotenen Angebote entweder meiner Institution oder mir selbst gehören und mir der Verkauf oder die kostenfreie Weitergabe gestattet ist." value={this.state.agreement_2} slot='agreement_2' update={this.update} />
          {!util.isCommercialUser() &&
           <AGBCheckBox value={this.state.agb_agreement} slot='agb_agreement' agbUrl="/ueberlassungsvereinbarung.pdf"
                        content1="Ich habe die " fileType="Überlassungsvereinbarung" content2=" gelesen und akzeptiere diese." update={this.update} />}
           {util.isCommercialUser() &&
            <AGBCheckBox value={this.state.agb_agreement} slot='agb_agreement' agbUrl="/einstellvertrag.pdf"
                         content1="Ich habe den " fileType="Einstellvertrag" content2=" gelesen und akzeptiere diesen." update={this.update} />}<br /><br />
          </div>
          <SubmitButton  history={this.props.history} onSubmit={this.save} />
          </div>

        </div>

        <Footer faqs={faqSoftware} />
        </div>
        {!util.isCommercialUser() && !util.isNonCommercialUser() &&
         <div>Sie besitzen nicht genügend Rechte, um eine Gebraucht-Software zu erstellen.</div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/other.js